<div *ngIf="host">
    <app-avatar [displayName]="host.displayName"
                [imageUrl]="host.imageUrl"></app-avatar>
</div>
